<script>
import ThemeSwitcher from '../ThemeSwitcher';
import feather from 'feather-icons';
import AppHeaderLinks from './AppHeaderLinks.vue';

export default {
	components: {
		ThemeSwitcher,
		AppHeaderLinks,
	},
	data() {
		return {
			isOpen: false,
			theme: '',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'dark';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'dark';
	},
	methods: {
		updateTheme(theme) {
			this.theme = theme;
		},
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<nav
		id="nav"
		class="sticky top-0 z-50 w-full"
		:class="theme === 'dark'
			? 'bg-primary-dark/80 backdrop-blur-xl border-b border-white/[0.06]'
			: 'bg-white/80 backdrop-blur-xl border-b border-gray-200/60 shadow-sm'"
	>
		<div class="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
			<div class="flex justify-between items-center h-16 sm:h-18">

				<!-- Logo -->
				<router-link to="/" class="flex-shrink-0">
					<img
						v-if="theme === 'light'"
						src="@/assets/images/logo/logo-light-theme.webp"
						class="w-28 sm:w-32"
						alt="Logo"
					/>
					<img
						v-else
						src="@/assets/images/logo/2.webp"
						class="w-28 sm:w-32"
						alt="Logo"
					/>
				</router-link>

				<!-- Desktop nav links -->
				<AppHeaderLinks :showModal="() => {}" :isOpen="false" class="hidden sm:flex px-2 py-1 rounded-lg border"
					:class="theme === 'dark' ? 'border-white/[0.07] bg-white/[0.035]' : 'border-gray-200 bg-gray-50/80'" />

				<!-- Right side controls -->
				<div class="flex items-center gap-3">
					<!-- Email Me button (desktop) -->
					<a
						href="mailto:arhamnatiq25@gmail.com"
						class="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-general-medium transition-all duration-300"
						:class="theme === 'dark'
							? 'text-white border border-white/20 hover:border-amber-500/60 hover:bg-amber-500/10'
							: 'text-gray-700 border border-gray-300 hover:border-amber-500 hover:bg-amber-50'"
						aria-label="Email Me"
					>
						<i data-feather="mail" class="w-3.5 h-3.5" />
						Email Me
					</a>

					<!-- Theme switcher -->
					<theme-switcher
						:theme="theme"
						@themeChanged="updateTheme"
						class="flex items-center justify-center w-9 h-9 rounded-lg transition-all duration-300 cursor-pointer"
						:class="theme === 'dark'
							? 'bg-white/5 hover:bg-white/10 border border-white/10'
							: 'bg-gray-100 hover:bg-gray-200 border border-gray-200'"
					/>

					<!-- Mobile hamburger -->
					<button
						@click="isOpen = !isOpen"
						type="button"
						class="sm:hidden flex items-center justify-center w-9 h-9 rounded-lg transition-all duration-300"
						:class="theme === 'dark'
							? 'bg-white/5 hover:bg-white/10 border border-white/10 text-white'
							: 'bg-gray-100 hover:bg-gray-200 border border-gray-200 text-gray-700'"
						aria-label="Menu"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="h-5 w-5 fill-current">
							<path
								v-if="isOpen"
								fill-rule="evenodd"
								d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
								clip-rule="evenodd"
							/>
							<path
								v-else
								fill-rule="evenodd"
								d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
							/>
						</svg>
					</button>
				</div>
			</div>

			<!-- Mobile menu -->
			<div
				v-if="isOpen"
				class="sm:hidden border-t py-4 space-y-1"
				:class="theme === 'dark' ? 'border-white/[0.06]' : 'border-gray-200'"
			>
				<AppHeaderLinks :showModal="() => {}" :isOpen="true" class="flex flex-col" />
				<div class="pt-3 border-t" :class="theme === 'dark' ? 'border-white/[0.06]' : 'border-gray-200'">
					<a
						href="mailto:arhamnatiq25@gmail.com"
						class="block px-3 py-2 rounded-lg text-sm font-general-medium transition-all duration-300"
						:class="theme === 'dark'
							? 'text-slate-300 hover:text-amber-300 hover:bg-white/5'
							: 'text-gray-600 hover:text-amber-600 hover:bg-amber-50'"
					>
						Email Me
					</a>
				</div>
			</div>
		</div>
	</nav>
</template>

<style scoped>
#nav a.router-link-exact-active {
	color: #f59e0b;
}
</style>
